import React, { useState } from 'react';
import { RecordOptions, DeleteModal } from '../../../../index.js';
import TenantSingleIcon from '../../../../../assets/images/module/general/TenantSingleIcon.svg';
import TenantLite from '../../../../../assets/images/module/general/TenantLite.svg';
import MovedInIcon from '../../../../../assets/images/module/general/MovedInIcon.svg';
import MovedOutIcon from '../../../../../assets/images/module/general/MovedOutIcon.svg';
import CalendarIcon from '../../../../../assets/images/module/general/CalendarIcon.svg';
import buildingIcon from '../../../../../assets/images/module/general/building_icon.svg';
import MultipleTenants from '../../../../../assets/images/module/general/MultipleTenants.svg';
import PropertyIcon from '../../../../../assets/images/module/general/PropertyIcon.svg';
import MeterIcon from '../../../../../assets/images/module/general/blueEmptyMeter.svg';
import EmptyApartmentIcon from '../../../../../assets/images/module/general/emptyApartmentIcon2.svg';
import {
  EmptyStateContainer,
} from '../../../../../neoverv';
import { deleteMeterReadings } from '../../../../../redux/action/Meter/meterActions';
import { connect } from 'react-redux';
import Autoload from '../../../../../neoverv/Autoload';
import moment from 'moment';
import { Group } from '@mantine/core';
var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const { checkProperty } = Autoload.MainHelper;

function MeterReadingRecord({
  data,
  className,
  labels,
  deleteMeterReadings,
  history,
  labelClassName,
  parent,
  billingPeriod,
  rentalUnitsExist
}) {
  const [openDelete, setOpenDelete] = useState(false);
  const [currentSelection, setCurrentSelection] = useState(0);
  const toggleDeleteModal = () => setOpenDelete(!openDelete);

  const editMeterReading = (data, period = 'start') => {
    const { billingPeriodId, periodStartReading, id } = data;
    history.push({
      pathname: `${Autoload.Setting.get_meter_reading_annual_link(billingPeriodId, 'c-r-0')}`,
      data: { ...data, period },
      edit: true,
    })
  };

  const deleteReading = (rowId) => {
    if (rowId == null) {
      return;
    }
    let btnelement = document.getElementById('meter_reading_delete_modal');
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.meter_api_base_url + 'readings/' + rowId,
      'DELETE',
      null,
      btnelement.children[1],
      false,
      true,
      false,
      parent,
      'handle_delete_reading_list_data',
      { rowId: rowId, closeModalFunc: toggleDeleteModal },
      false,
      ''
    );
  };

  const setIndexes = (rowIndex) => {
    setCurrentSelection(rowIndex);
  };

  const getTableLabels = () => {
    return labels.map((label, index) => {
      return (
        <td key={index} className={`${labelClassName[index]} d-none d-md-table-cell`}>
          {label}
        </td>
      );
    });
  };

  const renderOccasionIcon = (occasionName) => {
    switch (occasionName) {
      case 'Moved in':
      case 'move-in':
        return MovedInIcon;
      case 'Moved out':
      case 'move-out':
        return MovedOutIcon;
      case 'Annual':
      case 'annual':
        return CalendarIcon;
      case 'empty-tenant-move-out':
        return EmptyApartmentIcon;
      default:
        break;
    }
  };

  const renderOccasionName_de = (occasionName) => {
    switch (occasionName) {
      case 'Moved in':
      case 'move-in':
        return lang.tenant.text_move_in;
      case 'Moved out':
      case 'move-out':
        return lang.tenant.text_move_out;
      case 'Annual':
      case 'annual':
        return lang.meter.text_annual;
      case 'empty-tenant-move-out':
        return 'Leerstand';
      default:
        break;
    }
  };

  const getTableData = () => {
    const propertyHeading = (
      <Group gap={10} style={{ marginTop: '32px', marginBottom: '15px', marginLeft: '2px' }} wrap="nowrap">
        <img src={PropertyIcon} />
        <span style={{ fontSize: '16px', fontWeight: '600', marginTop: '4px', color: '#0E0E1D', whiteSpace: 'nowrap', fontFamily: 'Inter, sans-serif' }}>{'Ablesung Hauszähler'}</span>
      </Group>);
    
    const rentalUnitHeading = (
      <Group gap={10} style={{ marginTop: '32px', marginBottom: '15px', marginLeft: '2px' }} wrap="nowrap">
        <img src={MultipleTenants} style={{ marginTop: '4px' }} />
        <span style={{ fontSize: '16px', fontWeight: '600', marginTop: '4px', color: '#0E0E1D', whiteSpace: 'nowrap', fontFamily: 'Inter, sans-serif' }}>{'Ablesung Mieterzähler'}</span>
      </Group>);

    const columnHeaders = (<tr className="table-heading">{getTableLabels()}</tr>);

    // 1. Initial Filter
    const filteredOccupations = data.occupationReadings.filter((row) => (
      (!row.vacant) ||
      (row.vacant && row.periodEndReading?.occasion === 'annual') ||
      (row.vacant && row.periodEndReading?.occasion === 'move-in') ||
      (!row.rentalUnitName) // Always keep Property Meters
    ));

    // 2. Map-based Processing (Upsert/Merge Logic)
    const readingsMap = new Map();

    const upsertReading = (readingId, rowData, type, sortDate) => {
        if (!readingsMap.has(readingId)) {
            readingsMap.set(readingId, { ...rowData, type, sortDate, readingId });
        } else {
            const existing = readingsMap.get(readingId);
            if (existing.tenantFullName === '(leer)' && rowData.tenantFullName !== '(leer)') {
                 readingsMap.set(readingId, { ...rowData, type, sortDate, readingId });
            }
        }
    };

    filteredOccupations.forEach((row) => {
      // --- Start Reading Logic ---
      if (row.periodStartReading && row.periodStartReading.id) {
          const isValidStart = row.periodStartReading.occasionDate >= row.periodStart;
          
          if (isValidStart) {
              upsertReading(
                  row.periodStartReading.id, 
                  row, 
                  'start', 
                  row.periodStartReading.occasionDate
              );
          }
      }

      // --- End Reading Logic ---
      if (row.periodEndReading && row.periodEndReading.id) {
          upsertReading(
              row.periodEndReading.id, 
              row, 
              'end', 
              row.periodEndReading.occasionDate
          );
      }
    });

    // 3. Convert Map to List & Sort
    const flatList = Array.from(readingsMap.values());

    flatList.sort((a, b) => {
       const aIsProp = !a.rentalUnitName;
       const bIsProp = !b.rentalUnitName;
       
       if(aIsProp && !bIsProp) return -1;
       if(!aIsProp && bIsProp) return 1;

       const unitA = a.rentalUnitName || '';
       const unitB = b.rentalUnitName || '';
       const nameCompare = unitA.toLowerCase().localeCompare(unitB.toLowerCase());
       if(nameCompare !== 0) return nameCompare;

       return new Date(a.sortDate) - new Date(b.sortDate);
    });

    // 4. Rendering
    let renderedRows = [];
    let hasRenderedPropertyHeader = false;
    let hasRenderedUnitHeader = false;

    flatList.forEach((row, rowIndex) => {
      const isProperty = !row.rentalUnitName;

      // Inject Headers
      if (isProperty && !hasRenderedPropertyHeader) {
        renderedRows.push(propertyHeading);
        renderedRows.push(columnHeaders);
        hasRenderedPropertyHeader = true;
      }
      if (!isProperty && !hasRenderedUnitHeader) {
        renderedRows.push(rentalUnitHeading);
        if(!hasRenderedPropertyHeader) renderedRows.push(columnHeaders); 
        hasRenderedUnitHeader = true;
      }

      // Render Rows
      let periodStart = moment(checkProperty(row, 'periodStart'), 'YYYY-MM-DD').format('DD.MM.YYYY');
      let periodEnd = moment(checkProperty(row, 'periodEnd'), 'YYYY-MM-DD').format('DD.MM.YYYY');
      
      if (row.type === 'start') {
        let occasionDate = moment(checkProperty(row.periodStartReading, 'occasionDate'), 'YYYY-MM-DD').format('DD.MM.YYYY');

        renderedRows.push(
          <tr key={`start-${row.readingId}-${rowIndex}`} className="table-data" style={{ cursor: 'pointer' }} onClick={() => editMeterReading(row, 'start')}>
            <td className={`text-nl text-normal value-text-meter-rental `}>
              {row.rentalUnitName || '-'}
            </td>
            <td className={`text-nl text-normal value-text-meter-tenant d-none d-md-table-cell`} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              <img
                src={
                  row.tenantFullName === '(leer)'
                    ? TenantLite
                    : row.contractType === 'private'
                      ? TenantSingleIcon
                      : row.contractType === 'commercial'
                        ? buildingIcon
                        : null
                }
                alt=" "
              />
              {row.tenantFullName || '-'}
            </td>
            <td className={`text-nl text-normal value-text-occupency-dates d-none d-md-table-cell`}>
              {periodStart} - {periodEnd} ({checkProperty(row, 'periodDays')} {` ${lang.newKeys.text_days}`})
            </td>
            <td className={`text-nl text-normal value-text-meter-ocassion d-none d-md-table-cell`} style={{ whiteSpace: 'nowrap' }}>
              <img src={renderOccasionIcon(row.periodStartReading.occasion)} alt="occasion" className="status-icon-meter" />
              {renderOccasionName_de(row.periodStartReading.occasion)}
            </td>
            <td className={`text-nl text-normal value-text-meter-readingDate d-none d-md-table-cell`}>
              {occasionDate}
            </td>
            <td className="text-nl text-normal value-text-meter-empty " onClick={(e) => { e.stopPropagation(); setIndexes(rowIndex); }}>
              <RecordOptions
                toggleEditModal={() => editMeterReading(row, 'start')}
                showDeleteButton={false}
                showPrintButton={true}
                onPrint={() => window.open(`/meterReadingPdf/${data.billingPeriodData.id}?occupationReadings=${JSON.stringify([{ readingsId: row.periodStartReading.id, occupationId: row.id }])}`, '_blank')}
              />
            </td>
          </tr>
        );
      } else {
        // End Reading
        let occasionDate = moment(checkProperty(row.periodEndReading, 'occasionDate'), 'YYYY-MM-DD').format('DD.MM.YYYY');
        const isVacantMoveIn = row.tenantFullName === '(leer)' && row.periodEndReading.occasion === 'move-in';

        renderedRows.push(
          <tr key={`end-${row.readingId}-${rowIndex}`} className="table-data" onClick={() => editMeterReading(row, 'end')} style={{ cursor: 'pointer' }}>
            <td className={`text-nl text-normal value-text-meter-rental `}>
              {!row.rentalUnitName ? '-' : row.rentalUnitName}
            </td>
            <td className={`text-nl text-normal value-text-meter-tenant d-none d-md-table-cell`} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              <img
                src={
                  row.tenantFullName === '(leer)'
                    ? TenantLite
                    : row.contractType === 'private'
                      ? TenantSingleIcon
                      : row.contractType === 'commercial'
                        ? buildingIcon
                        : null
                }
                alt=""
              />
              {!row.tenantFullName ? '-' : row.tenantFullName}
            </td>
            <td className={`text-nl text-normal value-text-occupency-dates d-none d-md-table-cell`}>
              {periodStart} - {periodEnd} ({checkProperty(row, 'periodDays')} {` ${lang.newKeys.text_days}`})
            </td>
            <td className={`text-nl text-normal value-text-meter-ocassion d-none d-md-table-cell`} style={{ whiteSpace: 'nowrap' }}>
              {!isVacantMoveIn ? (
                <>
                  <img src={renderOccasionIcon(row.periodEndReading.occasion)} alt="occasion" className="status-icon-meter" />
                  {renderOccasionName_de(row.periodEndReading.occasion)}
                </>
              ) : (
                <>
                  <img src={renderOccasionIcon('empty-tenant-move-out')} alt="occasion" className="status-icon-meter" />
                  {renderOccasionName_de('empty-tenant-move-out')}
                </>
              )}
            </td>
            <td className={`text-nl text-normal value-text-meter-readingDate d-none d-md-table-cell`}>
              {isVacantMoveIn ? periodEnd : occasionDate}
            </td>
            <td className="text-nl text-normal value-text-meter-empty " onClick={(e) => { e.stopPropagation(); setIndexes(rowIndex); }}>
              <RecordOptions
                showDeleteButton={false}
                toggleEditModal={() => editMeterReading(row, 'end')}
                showPrintButton={true}
                onPrint={() => window.open(`/meterReadingPdf/${data.billingPeriodData.id}?occupationReadings=${JSON.stringify([{ readingsId: row.periodEndReading.id, occupationId: row.id }])}`, '_blank')}
              />
            </td>
          </tr>
        );
      }
    });
    
    // Empty state
    if (rentalUnitsExist === false) {
       return (
        <>
          <Group gap={10} style={{marginTop: '32px', marginBottom: '15px', marginLeft: '2px'}} wrap="nowrap">
            <img src={MultipleTenants} style={{marginTop: '4px'}}/> 
            <span style={{fontSize: '16px', fontWeight: '600', marginTop: '4px', color: '#0E0E1D', whiteSpace: 'nowrap', fontFamily: 'Inter, sans-serif'}}>{'Ablesung Mieterzähler'}</span>
          </Group>
          <tr>
            <td colSpan={6}>
              <EmptyStateContainer
                heading={'Ablesungen sind noch nicht verfügbar.'}
                subheading={'Legen Sie zunächst Mieteinheiten an, um Mieterablesungen durchzuführen.'}
                className="empty-meter-reading"
                icon={MeterIcon}
                styleMainContainer={{marginTop: '20px'}}
                btnHandler={() => parent.props.history.push('/user')}
                btnText={'Einheit hinzufügen'}
              />
            </td>
          </tr>
        </>
       )
    }

    return renderedRows;
  };

  console.log(data);
  return (
    <>
      <table className={`table borderless ${className} mb-0`}>
        <tbody>
          {getTableData()}
        </tbody>
        <DeleteModal
          modalId="meter_reading_delete_modal"
          record={data.occupationReadings[currentSelection]}
          className="delete-receipt-modal"
          open={openDelete}
          toggle={() => toggleDeleteModal()}
          handleDelete={deleteReading}
          type={lang.newKeys.text_record}
        />
      </table>
    </>
  );
}
export default connect(null, { deleteMeterReadings })(MeterReadingRecord);